// extracted by mini-css-extract-plugin
export default {"normal":"Button_normal__J6OYB","active":"Button_active__DJk-D","isDisabled":"Button_isDisabled__roOWc","delete":"Button_delete__otmfg"};